module.exports = __webpack_public_path__ + "static/media/trumpet.546c2abb.svg";